import { useSeo } from "~/hooks/useSeo";
import { trans } from "~/providers/lang";

export default function Page404() {
	useSeo({
		title: trans("skelet.title.page404").replace("<br />", " "),
		canonical: "404",
	});

	return <div className="body-background">
		<div className="page-content top-shadow">
			<h1 className="other-page-title" dangerouslySetInnerHTML={{ __html: trans('skelet.title.page404') }} />
		</div>
	</div>;
}
